export type Download = {
  sku?: string;
  url?: string;
  fileName?: string;
  fileType?: string;
  downloadType: DownloadType;
  thumbnail?: string;
  date: string;
};

export enum DownloadType {
  LibraryDownload = 'LibraryDownload',
  PressDownload = 'PressDownload',
}

export type DownloadCreatePayload = {
  sku?: string;
  url: string;
  fileName?: string;
  fileType?: string;
  downloadType: DownloadType;
  thumbnail?: string;
};
